import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_2 = { class: "ellipsis" }
const _hoisted_3 = { class: "business-selector__item" }
const _hoisted_4 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_5 = {
  key: 0,
  class: "business-selector__counter"
}
const _hoisted_6 = { class: "v-input__error" }
const _hoisted_7 = { class: "business-selector__row" }
const _hoisted_8 = { class: "business-selector__row" }
const _hoisted_9 = { class: "business-selector__row" }
const _hoisted_10 = { class: "business-selector__row" }
const _hoisted_11 = { class: "business-selector__row" }
const _hoisted_12 = {
  key: 5,
  class: "business-selector__no-items"
}

import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useDataStore } from '@/stores/data';
import VAuthInput from './VAuthInput.vue';
import VSelect from './VSelect.vue';
import SearchIcon from './icons/other/SearchIcon.vue';
import VCollapse from './VCollapse.vue';
import VCheckbox from './VCheckbox.vue';
import VAvatar from './VAvatar.vue';
import VIconButton from './VIconButton.vue';
import CloseIcon from './icons/navigation/CloseIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BusinessesSelector',
  props: {
    modelValue: null,
    small: { type: Boolean },
    error: null,
    socialFilter: null,
    showCampagins: { type: Boolean },
    showInstagrams: { type: Boolean }
  },
  emits: [ "update:modelValue" ],
  setup(__props: any, { emit }) {

const props = __props as { 
  modelValue: App.Assets,
  small?: boolean,
  error?: string,
  socialFilter?: string | null,
  showCampagins?: boolean,
  showInstagrams?: boolean
}




const assetsCount = computed(() => {
  return (props.modelValue.businesses?.length || 0) +
    (props.modelValue.pages?.length || 0) +
    (props.modelValue.ad_accounts?.length || 0) +
    (props.modelValue.campaigns?.length || 0)
})

const searchValue = ref("")
const filterItems = (arr: { id: number, name: string, picture?: string, type_id: number, bm?: any, ad_account?: any, page?: any }[], key: keyof App.Assets) => {
  let _arr = arr
  if (props.socialFilter) {
    _arr = _arr.filter(item => (props.socialFilter === "fb" && item.type_id === 1 || item.type_id === 2) || (props.socialFilter === "tiktok" && item.type_id === 3)) 
  }
  if (key === "pages" && !props.showInstagrams) {
    _arr = _arr.filter(item => item.type_id !== 2)
  }

  if (!searchValue.value) return _arr
  const val = searchValue.value.toLowerCase()
  return _arr.filter(item => item.name.toLowerCase().includes(val))
}

const dataStore = useDataStore()
const items = computed(() => ({
  accounts: filterItems(dataStore.accounts, "accounts"),
  businesses: filterItems(dataStore.businesses, "businesses"),
  pages: filterItems(dataStore.pages, "pages"),
  ad_accounts: filterItems(dataStore.ad_accounts, "ad_accounts"),
  campaigns: filterItems(dataStore.campaigns, "campaigns")
}))
const noItems = computed(() => {
  return items.value.businesses.length === 0 && items.value.pages.length === 0 && items.value.ad_accounts.length === 0 && items.value.campaigns.length === 0
})
const opened = computed(() => (items.value.businesses.length + items.value.ad_accounts.length + items.value.pages.length) < 9)

const keys: (keyof App.Assets)[] = ["accounts", "businesses", "pages", "ad_accounts", "campaigns" ]
const selection = reactive<Record<keyof App.Assets, Record<number | string, "all" | "part" | undefined>>>({
  accounts: {},
  businesses: {},
  pages: {},
  ad_accounts: {},
  campaigns: {}
})

onMounted(() => {
  for (let key of keys) {
    if (key === "businesses") continue
    if (!props.modelValue[key]) continue
    for (let itemId of props.modelValue[key]!) {
      const asset = dataStore[key].find(item => item.id === itemId)
      if (!asset) continue
      if (key === "pages" && asset.type_id === 2 && !props.showInstagrams) continue
      update(asset, key, true, true, false)
    }
  }
  for (let itemId of (props.modelValue.businesses || [])) {
    if (selection.businesses[itemId]) continue
    const item = dataStore.businesses.find(item => item.id === itemId)
    if (!item) continue
    update(item, "businesses", true, true, false)
  }
  updateModel()
})

const isFullfilled = (bm: any, passive = false) => {
  if (passive && selection["pages"][bm.id] === "all") {
    return "all"
  }
  let hasItems = false
  let fullFilled = true
  for (let key of keys) {
    if (!bm[key]) continue
    for (let asset of bm[key]) {
      if (key === "pages" && asset.type_id === 2 && !props.showInstagrams) continue
      if (selection[key][asset.id]) {
        hasItems = true
      }
      if (!selection[key][asset.id]) {
        fullFilled = false
      }
    }
  }
  if (!hasItems) {
    return undefined
  }
  if (fullFilled && !passive) {
    return "all"
  }
  return "part"
}

const getType = (item: any): keyof App.Assets => {
  for (let key of keys) {
    if (items.value[key].find(_item => _item === item)) return key
  }
  return "businesses"
}

const update = (item: any, type: keyof App.Assets, value: boolean, updateParent = true, updateModelValue = true) => {
  if (value) {
    selection[type][item.id] = "all"
  } else {
    delete selection[type][item.id]
  }
  for (let key of keys) {
    if (!item[key]) continue
    for (let asset of item[key]) {
      if (key === "pages" && asset.type_id === 2 && !props.showInstagrams) continue
      update(asset, key, value, false, false)
    }
  }

  if (type === "businesses") {
    const relatedAccounts = findAccountsByBusiness(item)
    for (let account of relatedAccounts) {
      selection["accounts"][account.id] = value ? "all" : undefined
    }
  }

  if (updateParent) {
    if (item.bm) {
      selection["businesses"][item.bm.id] = isFullfilled(item.bm)
    }
    if (item.ad_account) {
      selection["ad_accounts"][item.ad_account.id] = isFullfilled(item.ad_account)
      if (item.ad_account.bm) {
        selection["businesses"][item.ad_account.bm.id] = isFullfilled(item.ad_account.bm)
      }
    }
  }
  if (updateModelValue) {
    updateModel()
  }
}

function findAccountsByBusiness(business: any) {
  return dataStore.accounts.filter(acc =>
    Array.isArray(acc.businesses) &&
    acc.businesses.some(b => b.id === business.id)
  )
}

const updateModel = () => {
  for (let key of keys) {
    if (key === "campaigns" && !props.showCampagins) continue
    props.modelValue[key] = Object.entries(selection[key])
      .filter(([ id, value ]) => value === "all" || (key === "businesses" && value === "part"))
      .map(([ id ]) => key === "pages"? id: (id))
  }
  emit("update:modelValue", props.modelValue)
}

const collapseRef = ref<any[]>([])

const viewData = computed(() => {
  const arr = []
  for (let key of keys) {
    for (let item of items.value[key]) {
      if (item.bm && selection["businesses"][item.bm.id] === "all") continue
      if (item.ad_account && selection["ad_accounts"][item.ad_account.id] === "all") continue
      if (item.page && selection["pages"][item.page.id] === "all") continue
      
      if (selection[key][item.id] === "all") {
        arr.push(item)
      }
    }
  }
  return arr
})

const isGroupChecked = (key: keyof App.Assets): boolean => {
  const groupItems = items.value[key]
  return groupItems.length > 0 && groupItems.every(item => selection[key][item.id] === 'all')
}

const isGroupPartiallyChecked = (key: keyof App.Assets): boolean => {
  const groupItems = items.value[key]
  const selectedCount = groupItems.filter(item => selection[key][item.id] === 'all').length
  return selectedCount > 0 && selectedCount < groupItems.length
}

const toggleGroup = (key: keyof App.Assets, value: boolean) => {
  const groupItems = items.value[key]
  for (const item of groupItems) {
    update(item, key, value, true, false)
  }
  updateModel()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VSelect, {
    class: _normalizeClass(["business-selector", { 'business-selector__small': props.small, errored: !!props.error  }]),
    "mobile-close": "",
    "selected-value": _unref(assetsCount)
  }, {
    default: _withCtx(() => [
      (!props.small)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(viewData).length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Select assets"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewData), (item) => {
                return (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createVNode(VAvatar, {
                    src: item.picture
                  }, null, 8, ["src"]),
                  _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                  _createVNode(VIconButton, {
                    onClick: _withModifiers(($event: any) => (update(item, getType(item), false)), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CloseIcon)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              }), 256))
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createTextVNode(" Assets "),
            (_unref(assetsCount) > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(assetsCount)), 1))
              : _createCommentVNode("", true)
          ])),
      _createElementVNode("div", _hoisted_6, _toDisplayString(props.error), 1)
    ]),
    top: _withCtx(() => [
      _createVNode(VAuthInput, {
        modelValue: searchValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
        icon: SearchIcon,
        placeholder: "Search",
        class: "mx-2 light business-selector__search",
        clearable: ""
      }, null, 8, ["modelValue"]),
      (_unref(items).accounts.length > 1)
        ? (_openBlock(), _createBlock(VCollapse, {
            key: 0,
            ref: r => collapseRef.value[4] = r,
            title: "PROFILES",
            class: "mx-2 business-selector__collapse",
            opened: _unref(opened)
          }, {
            default: _withCtx(() => [
              _createVNode(VCheckbox, {
                "model-value": isGroupChecked('accounts'),
                alt: isGroupPartiallyChecked('accounts'),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = val => toggleGroup('accounts', val)),
                label: "All"
              }, null, 8, ["model-value", "alt"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).accounts, (item) => {
                return (_openBlock(), _createBlock(VCheckbox, {
                  "model-value": !!selection.accounts[item.id],
                  "onUpdate:modelValue": value => update(item, 'accounts', value)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(VAvatar, {
                        src: item.picture,
                        type: item.type_id
                      }, null, 8, ["src", "type"]),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["model-value", "onUpdate:modelValue"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["opened"]))
        : _createCommentVNode("", true),
      (_unref(items).businesses.length > 0)
        ? (_openBlock(), _createBlock(VCollapse, {
            key: 1,
            ref: r => collapseRef.value[0] = r,
            title: "BMs",
            class: "mx-2 business-selector__collapse",
            opened: _unref(opened)
          }, {
            default: _withCtx(() => [
              _createVNode(VCheckbox, {
                "model-value": isGroupChecked('businesses'),
                alt: isGroupPartiallyChecked('businesses'),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = val => toggleGroup('businesses', val)),
                label: "All"
              }, null, 8, ["model-value", "alt"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).businesses, (item) => {
                return (_openBlock(), _createBlock(VCheckbox, {
                  "model-value": !!selection.businesses[item.id],
                  alt: selection.businesses[item.id] === 'part',
                  "onUpdate:modelValue": value => update(item, 'businesses', value)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(VAvatar, {
                        src: item.picture,
                        type: item.type_id
                      }, null, 8, ["src", "type"]),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["model-value", "alt", "onUpdate:modelValue"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["opened"]))
        : _createCommentVNode("", true),
      (_unref(items).pages.length > 0)
        ? (_openBlock(), _createBlock(VCollapse, {
            key: 2,
            ref: r => collapseRef.value[1] = r,
            title: "PAGES",
            class: "mx-2 business-selector__collapse",
            opened: _unref(opened)
          }, {
            default: _withCtx(() => [
              _createVNode(VCheckbox, {
                "model-value": isGroupChecked('pages'),
                alt: isGroupPartiallyChecked('pages'),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = val => toggleGroup('pages', val)),
                label: "All"
              }, null, 8, ["model-value", "alt"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).pages, (item) => {
                return (_openBlock(), _createBlock(VCheckbox, {
                  "model-value": !!selection.pages[item.id],
                  "onUpdate:modelValue": value => update(item, 'pages', value)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(VAvatar, {
                        src: item.picture,
                        type: item.type_id
                      }, null, 8, ["src", "type"]),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["model-value", "onUpdate:modelValue"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["opened"]))
        : _createCommentVNode("", true),
      (_unref(items).ad_accounts.length > 0)
        ? (_openBlock(), _createBlock(VCollapse, {
            key: 3,
            ref: r => collapseRef.value[2] = r,
            title: "AD ACCOUNTS",
            class: "mx-2 business-selector__collapse",
            opened: _unref(opened)
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).ad_accounts, (item) => {
                return (_openBlock(), _createBlock(VCheckbox, {
                  "model-value": !!selection.ad_accounts[item.id],
                  alt: selection.ad_accounts[item.id] === 'part',
                  "onUpdate:modelValue": value => update(item, 'ad_accounts', value)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(VAvatar, {
                        src: item.picture,
                        type: item.type_id
                      }, null, 8, ["src", "type"]),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["model-value", "alt", "onUpdate:modelValue"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["opened"]))
        : _createCommentVNode("", true),
      (props.showCampagins && _unref(items).campaigns.length > 0)
        ? (_openBlock(), _createBlock(VCollapse, {
            key: 4,
            ref: r => collapseRef.value[3] = r,
            title: "AD CAMPAIGNS",
            class: "mx-2 business-selector__collapse",
            opened: _unref(opened)
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).campaigns, (item) => {
                return (_openBlock(), _createBlock(VCheckbox, {
                  "model-value": !!selection.campaigns[item.id],
                  "onUpdate:modelValue": value => update(item, 'campaigns', value)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(VAvatar, {
                        src: item.picture,
                        type: item.type_id
                      }, null, 8, ["src", "type"]),
                      _createTextVNode(" " + _toDisplayString(item.name), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["model-value", "onUpdate:modelValue"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["opened"]))
        : _createCommentVNode("", true),
      (_unref(noItems))
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "No items yet"))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "selected-value"]))
}
}

})